import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PersonEditPage } from './PersonEditPage';

// This wrapper component uses React Router v6 hooks and passes them as props
// to the class component in a format compatible with React Router v5
export function PersonEditPageWrapper(props) {
  const params = useParams();
  const navigate = useNavigate();
  
  // Create a history object that mimics the React Router v5 history
  const history = {
    push: (path) => navigate(path),
    location: window.location,
  };
  
  // Create a match object that mimics the React Router v5 match
  const match = {
    params,
    url: window.location.pathname,
  };
  
  return <PersonEditPage {...props} match={match} history={history} />;
}
